const data = {
  "insurance": {
    "oneTimeCost": "Eenmalige kosten",
    "choosePaymentType": "Kies een flexibele of vaste looptijd",
    "oneTimePayment": "eenmalig",
    "monthly": "per maand",
    "annualPayment": "{{duration}} jaar vooruitbetalen <strong>{{price}}</strong> eenmalig ({{yearlyPrice}} per jaar)",
    "monthlyPayment": "Maandelijks opzegbaar <strong>{{price}}</strong> per maand ({{yearlyPrice}} per jaar)",
    "yearlyPrice": "({{yearlyPrice}} per jaar)",
    "insuranceProductDetailsTitle": "Waarvoor ben je verzekerd?",
    "insuranceProductDetailsDescription": "Hieronder vind je een overzicht van de belangrijkste onderdelen die worden vergoed. In de algemene voorwaarden vind je een compleet overzicht.",
    "insuranceMoreInfoTitle": "Wil je nog meer weten?",
    "generalConditionsUrl": "Bekijk algemene voorwaarden",
    "backupPlansUrl": "Bekijk alles over zekerheidspakketten",
    "addInsurance": "Verzekering toevoegen",
    "addExtendedWarranties": "Extended Warranty toevoegen",
    "extendedWarranties": {
      "moreInformation": "Wil je meer weten?",
      "generalInformation": "Alle informatie over Coolblue Extended Warranty",
      "termsAndConditions": "Algemene voorwaarden",
      "exchangeInformation": "Je kunt je aankoop binnen 30 dagen kosteloos omruilen of retourneren."
    },
    "information": {
      "exclusions": {
        "title": "Waar ben ik niet voor verzekerd?"
      },
      "attributes": {
        "title": "Wat gebeurt er bij schade of diefstal?",
        "description": "Als de schade onder de verzekering valt, probeert Coolblue je {{productType}} eerst te repareren. Is reparatie te duur, niet mogelijk, of is je {{productType}} gestolen? Dan krijg je de aankoopprijs terug in CoolblueTegoed. Je kan dan zelf een nieuw product uitkiezen."
      },
      "attributesWithoutTheft": {
        "title": "Wat gebeurt er wanneer mijn {{productType}} kapot is?",
        "description": "Als de schade onder de verzekering valt, probeert Coolblue je {{productType}} eerst te repareren. Is reparatie niet mogelijk of te duur? Dan krijg je de aankoopprijs terug in CoolblueTegoed. Zo kies je zelf een nieuw product."
      },
      "cancellation": {
        "title": "Bedenktijd en opzeggen",
        "description": {
          "nl": {
            "oneTime": "Je kan je verzekering tot {{days}} dagen na afsluiten gratis opzeggen. Ook als je het product wil houden. Onze klantenservice kan je hierbij helpen. Zolang je geen claim hebt ingediend, krijg je alle vooruitbetaalde premie terug. Na {{days}} dagen kun je een vooruitbetaalde verzekering niet meer opzeggen.",
            "monthly": "Je kan je verzekering tot {{days}} dagen na afsluiten gratis opzeggen. Ook als je het product wil houden. Onze klantenservice kan je hierbij helpen. Zolang je geen claim hebt ingediend, krijg je alle vooruitbetaalde premie terug. Een maandelijkse verzekering kun je ook na 30 dagen op elk moment stopzetten. Je betaalt dan premie tot de maand waarin je 'm opzegt. Als je 'm zelf niet stopzet, loopt je verzekering automatisch na 5 jaar af."
          },
          "be": {
            "oneTime": "Je kan je verzekering tot {{days}} dagen na afsluiten gratis opzeggen. Ook als je het product wil houden. Onze klantenservice kan je hierbij helpen. Zolang je geen claim hebt ingediend, krijg je alle vooruitbetaalde premie terug. Na {{days}} dagen kun je je verzekering jaarlijks opzeggen, uiterlijk drie maanden voor het einde van elk jaar dat de verzekering loopt.",
            "monthly": "Je kan je verzekering tot {{days}} dagen na afsluiten gratis opzeggen. Ook als je het product wil houden. Onze klantenservice kan je hierbij helpen. Zolang je geen claim hebt ingediend, krijg je alle vooruitbetaalde premie terug. Een maandelijkse verzekering kun je ook na 30 dagen op elk moment stopzetten. Je betaalt dan premie tot de maand waarin je 'm opzegt. Als je 'm zelf niet stopzet, loopt je verzekering automatisch na 5 jaar af."
          },
          "de": {
            "oneTime": "Je kan je verzekering tot {{days}} dagen na afsluiten gratis opzeggen. Ook als je het product wil houden. Onze klantenservice kan je hierbij helpen. Zolang je geen claim hebt ingediend, krijg je alle vooruitbetaalde premie terug. Na {{days}} dagen kun je een vooruitbetaalde verzekering niet meer opzeggen.",
            "monthly": "Je kan je verzekering tot {{days}} dagen na afsluiten gratis opzeggen. Ook als je het product wil houden. Onze klantenservice kan je hierbij helpen. Zolang je geen claim hebt ingediend, krijg je alle vooruitbetaalde premie terug. Een maandelijkse verzekering kun je ook na 30 dagen op elk moment stopzetten. Je betaalt dan premie tot de maand waarin je 'm opzegt. Als je 'm zelf niet stopzet, loopt je verzekering automatisch na 5 jaar af."
          }
        }
      },
      "provider": {
        "title": "Verzekering van XCover",
        "description": "De polis wordt geleverd door Cover Genius Europe B.V. als XCover.com. Dit bedrijf is geregistreerd bij de Nederlandse Kamer van Koophandel onder nummer 73237426. Het heeft een vergunning als assurantietussenpersoon en gevolmachtigd agent bij de Autoriteit Financiële Markten (AFM) onder nummer 12046177. Coolblue is een nevenverzekeringstussenpersoon van Cover Genius Europe B.V.De polis wordt verzekerd door Axeria iard. Dit bedrijf is geregistreerd bij het Registre du Commerce et des Sociétés de Lyon onder nummer B 352 893 200. Het is bevoegd door de Franse Autoriteit voor Prudentieel Toezicht en Resolutie (ACPR) om verzekeringszaken uit te voeren. Het ACPR is gevestigd op 4 Place de Budapest, 75009 Parijs."
      }
    },
    "ipid": "IPID (Verzekeringskaart)",
    "termsAndConditions": "Algemene voorwaarden",
    "readMore": "Lees meer over verzekeringen",
    "selector": {
      "groupTitle": {
        "monthly": "Maandelijks opzegbaar",
        "yearlySingular": "{{durationInYears}} jaar"
      },
      "chooseTerm": "Kies je looptijd",
      "chooseCoverage": "Kies je dekking",
      "viewAllInsuranceOptions": "Toon alle zekerheidspakketten",
      "configurePackage": "Stel je zekerheidspakket samen",
      "recommendedLabel": "Aanbevolen",
      "noInsurance": {
        "title": {
          "default": "Nee, ik wil niet verzekeren",
          "defaultWithProductType": "Nee, ik wil mijn {{- productType}} niet verzekeren",
          "extendedWarranty": "Standaard garantie"
        },
        "description": {
          "default": "Standaard fabrieksgarantie",
          "extendedWarranty": "Fabrieksfouten binnen garantie"
        },
        "included": "Inbegrepen"
      }
    }
  }
};

export default data;